import api from './leadsApi';

export const getUpworkStatus = () => api.get('/upwork/status');
export const getUpworkAuthUrl = () => api.get('/upwork/auth-url');
export const disconnectUpwork = () => api.post('/upwork/disconnect');
export const getUpworkRoomsStatus = () => api.get('/upwork/rooms/status');
export const syncUpworkRooms = () => api.post('/upwork/rooms/sync');
export const getUpworkProposalsStatus = () => api.get('/upwork/proposals/status');
export const syncUpworkProposals = () => api.post('/upwork/proposals/sync');
